import React from "react";
import { useSelector } from "react-redux";
import { getElementById } from "../utils/styleUtils";
export const CustomRadio = ({ instanceId, field, form, ...props }) => {
  const formBuilder = useSelector((state) => state.customFormBuilder);
  const element = getElementById(instanceId, formBuilder);

  if (!element) {
    return <div>Radio element not found</div>;
  }

  const elementStyle = element.style || {};

  const handleInputChange = (value) => {
    if (field && form) {
      form.setFieldValue(field.name, value);
    }
  };

  const getContainerStyles = () => {
    return {
      padding: elementStyle.padding || "0.5rem",
      marginLeft: elementStyle.marginLeft || "0",
      marginRight: elementStyle.marginRight || "0",
      width: elementStyle.width || "100%",
      marginTop: elementStyle.marginTop || "0",
      marginBottom: elementStyle.marginBottom || "0.75rem",
      backgroundColor: elementStyle.backgroundColor || "transparent",
      borderRadius: elementStyle.borderRadius || "0.375rem",
      borderStyle: elementStyle.borderStyle || "none",
      borderColor: elementStyle.borderColor || "#ced4da",
      borderWidth: elementStyle.borderWidth || "0",
    };
  };

  const getLabelStyles = () => {
    return {
      fontSize: elementStyle.fontSize || "0.875rem",
      color: elementStyle.textColor || "#212529",
      marginBottom: "0.5rem",
      fontWeight: elementStyle.labelFontWeight || "500",
    };
  };

  const getRadioStyles = () => {
    return {
      width: elementStyle.radioSize || "1rem",
      height: elementStyle.radioSize || "1rem",
      accentColor: elementStyle.radioColor || "#0d6efd",
      cursor: "pointer",
    };
  };

  const getOptionLabelStyles = () => {
    return {
      fontSize: elementStyle.optionFontSize || "0.875rem",
      color: elementStyle.optionTextColor || "#495057",
      marginLeft: "0.5rem",
      cursor: "pointer",
    };
  };

  const getOptionsContainerStyles = () => {
    const isHorizontal = elementStyle.optionsLayout === "horizontal";
    const optionsPerRow = elementStyle.optionsPerRow || 2;

    return {
      display: isHorizontal ? "grid" : "block",
      gridTemplateColumns: isHorizontal
        ? `repeat(${optionsPerRow}, 1fr)`
        : "none",
      gap: isHorizontal ? "0.5rem" : "0",
      width: "100%",
    };
  };

  const getOptionItemStyles = () => {
    const isHorizontal = elementStyle.optionsLayout === "horizontal";

    return {
      padding: "0.375rem",
      borderRadius: "0.25rem",
      backgroundColor: "transparent",
      transition: "background-color 0.15s ease-in-out",
      marginBottom: isHorizontal ? "0" : "0.5rem",
    };
  };

  const options = elementStyle.options || ["Option 1", "Option 2"];

  return (
    <div style={getContainerStyles()}>
      {elementStyle.label?.label && (
        <label className="form-label" style={getLabelStyles()}>
          {elementStyle.label.label}
          {elementStyle.isRequired && (
            <span style={{ color: "#dc3545", marginLeft: "0.2rem" }}>*</span>
          )}
        </label>
      )}

      <div style={getOptionsContainerStyles()}>
        {options.map((option, index) => (
          <div
            key={index}
            className="d-flex align-items-center"
            style={{
              ...getOptionItemStyles(),
              backgroundColor:
                field?.value === option
                  ? "rgba(13, 110, 253, 0.05)"
                  : "transparent",
            }}
          >
            <input
              id={`radio-${instanceId}-${index}`}
              type="radio"
              name={`radio-group-${instanceId}`}
              checked={field?.value === option}
              onChange={() => handleInputChange(option)}
              required={elementStyle.isRequired && index === 0}
              style={getRadioStyles()}
              className="form-check-input"
              {...props}
            />
            <label
              htmlFor={`radio-${instanceId}-${index}`}
              className="mb-0 w-100"
              style={getOptionLabelStyles()}
            >
              {option}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};